<template>
    <tr 
        class="site">
        <template
            v-if="first">
            <td colspan="8">
                <span 
                    v-if="loaded"
                    class="badge"> 
                    Page {{ site.location }} is loaded, pinging Location..
                </span>
                <span 
                    v-if="!loaded"
                    class="badge">
                    Page {{ site.location }} is preloading..
                </span>
            </td>
        </template>
        <template
            v-if="!first">
            <td>
                <button
                    :disabled="pinging"
                    @click="ping">
                    <span v-if="!pinging">Ping</span>
                    <span v-if="pinging && pings.length < originalTimes">Pinging.. {{ pings.length + 1 }} / {{ originalTimes }}</span>
                </button>
            </td>
            <td>
                <span
                    :class="typeClass" 
                    class="badge">
                    {{ site.type }}
                </span>
            </td>
            <td>
                <a
                    :href="site.url"
                    target="blank">
                    {{ site.location }}
                </a>
            </td>
            <td>
                <span v-if="lastPings.length > 0"> {{ best }}&nbsp;ms</span>
                <span v-if="lastPings.length == 0"> - </span>
            </td>
            <td>
                <span v-if="lastPings.length > 0"> {{ average }}&nbsp;ms</span>
                <span v-if="lastPings.length == 0"> - </span>
            </td>
            <td>
                <span v-if="lastPings.length > 0"> {{ worst }}&nbsp;ms</span>
                <span v-if="lastPings.length == 0"> - </span>
            </td>
            <td>
                <span v-if="lastPings.length > 0"> {{ jitter }}&nbsp;ms</span>
                <span v-if="lastPings.length == 0"> - </span>
            </td>
            <td>
                <span
                    v-if="!error">{{ health }}</span>
                <span
                    v-if="error"
                    class="badge badge--error"> TARGET UNREACHABLE </span>
            </td>
        </template>
    </tr>
</template>

<script>
import Ping from '../utils/ping';
export default {
    name: 'z-site',
    props: {
        site: {
            type: Object,
            default: () => ({})
        },
        wait: {
            type: Number,
            default: 200
        },
        originalTimes: {
            type: Number,
            default: 10
        }
    },
    data () {
        return {
            pinger: new Ping(),
            first: true,
            loaded: false,
            pings: [],
            lastPings: [],
            times: this.originalTimes,
            pinging: false,
            error: false,
            loading: true,
        };
    },

    computed: {
        best() {
            return Math.min(...this.lastPings);
        },
        worst() {
            return Math.max(...this.lastPings);
        },
        average() {
            return this.lastPings.reduce( ( p, c ) => p + c, 0 ) / this.lastPings.length;
        },
        jitter() {
            return this.worst - this.best;
        },
        health() {
            let health = 'Inadequate',
                jitter = '';

            if (this.average < 300) {
                health = 'Slow';
            }
            if (this.average < 200) {
                health = 'Good';
            }
            if (this.average < 100) {
                health = 'Excellent';
            }
            if (this.worst - this.best > 100) {
                jitter = ' but with jitter';
            }
            if (this.worst - this.best > 200) {
                jitter = ' but with bad jitter';
            }
            if (this.worst - this.best > 300) {
                jitter = ' unacceptable jitter';
            }
            return health + jitter;
        },

        typeClass() {
            return 'badge--' + this.site.type.toLowerCase();
        }
    },

    watch: {
        first: function (val, oldVal) {
            if (!val && !this.loaded) {
                this.loaded = true;
                this.first = true;
                this.ping();
            }
        },
        originalTimes: function (val) {
            this.times = val;
        }
    },

    mounted() {
        this.ping();
    },

    methods: {
        ping() {
            this.pinging = true;
            this.pinger.pingAjax(this.site.url, (error, response) => {
                if (error) {
                    this.first = false;
                    this.error = 'Ping failed';
                    this.lastPings = this.pings;
                    this.pings = [];
                    this.pinging = false;
                    this.times = this.originalTimes;
                } else {
                    if (this.times > 0){
                        this.times--;
                        this.pings.push(response);
                        this.ping();
                    } else {
                        this.first = false;
                        this.lastPings = this.pings;
                        this.pings = [];
                        this.pinging = false;
                        this.times = this.originalTimes;
                    }
                }
            });
        }
    }
};
</script>
